import clsx from 'clsx'
import { BillingEntryType } from '../store/schemas'

interface BillingEntryTypePillProps {
  entryType: BillingEntryType
}

/**
 * Billing Entry Type Pill
 *
 * Displays a pill for the billing entry type with color-coded styling.
 */
export default function BillingEntryTypePill({ entryType }: BillingEntryTypePillProps) {
  // Common styling classes for all entry types
  // Small-caps baseline sits lower, so we add padding-bottom to balance vertical centering
  const commonClasses = 'px-1 pt-0 pb-[1px] rounded text-xs [font-variant:small-caps] border w-fit inline-flex items-center min-h-[18px]'

  switch (entryType) {
    case BillingEntryType.MEDICAL_BILL:
      return <div className={clsx(commonClasses, 'text-brand-neutral-600 bg-brand-neutral-200 border-brand-neutral-300')}>medical bill</div>
    case BillingEntryType.ADJUSTMENT:
      return <div className={clsx(commonClasses, 'text-yellow-800 bg-yellow-100 border-yellow-200')}>adjustment</div>
    case BillingEntryType.PAYMENT:
      return <div className={clsx(commonClasses, 'text-brand-800 bg-brand-100 border-brand-200')}>payment</div>
    default: {
      // Exhaustiveness check: TypeScript will error if a new status is added and not handled
      const _exhaustive: never = entryType
      return _exhaustive
    }
  }
}
